import { apiRequest } from "@/api";
import { ENDPOINTS } from "@/api/endpoints";
import { CURRENT_PUSH_NOTIFICATION_PROVIDER, PUSH_NOTIFICATION_PROVIDERS } from "../pwa.constants";

export function useUnregisterPushOnLogout() {
  async function unregisterPush() {
    if (CURRENT_PUSH_NOTIFICATION_PROVIDER !== PUSH_NOTIFICATION_PROVIDERS.Native) return;
    if (!("serviceWorker" in navigator)) return;

    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();
      if (!subscription) return;

      await apiRequest<string>({
        method: "POST",
        path: ENDPOINTS.notificationUnregisterPush,
        body: { endpoint: subscription.endpoint },
      });
    } catch {}
  }

  return { unregisterPush };
}
